import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  breakpoints: {
    keys: ['xs', 'sm', 'md', 'lg', 'xl'],
    values: {
      xs: 0,
      sm: 600,
      md: 992,
      lg: 1200,
      xl: 1440,
    },
  },
});
